class CompanyCorporateUIModel {
  constructor({
    companyId,
    companyLoyaltyNumber,
    companyName,
    discountCode = '',
    emailAddress,
    emailAddressCompany,
    travelerId,
  } = {}) {
    this.discountCode = discountCode;
    this.companyId = companyId;
    this.companyLoyaltyNumber = companyLoyaltyNumber;
    this.companyName = companyName;
    this.emailAddress = emailAddress;
    this.emailAddressCompany = emailAddressCompany;
    this.travelerId = travelerId;
    this.isSelected = false;
  }
  
  setCompanySelected(value) {
    this.isSelected = value;
  }
}
  
export default CompanyCorporateUIModel;